<template>
  <div>
    <!-- <div v-for="(item, index) in selData" :key="index"> -->
    <CascaderSelectComp v-for="(item, index) in selData" :key="index" ref="cascaders" :type-data="item" :step-key="index" :width="width ? width : null" @change-child="changeChild" />
    <!-- </div> -->
  </div>
</template>

<script>
import CascaderSelectComp from "@/components/sift/CascaderSelectComp";

export default {
  name: "CascaderComp",
  props: ["type-data", "width", "colspan"],
  components: {
    CascaderSelectComp
  },
  data() {
    return {
      selData: []
    };
  },
  created() {
    this.selData.push(this.typeData);
  },
  computed: {},
  mounted() {
    this.$on("get-value", () => {
      this.getValue();
    });
  },
  methods: {
    changeChild(value, key, hasChild) {
      // console.log(this.selData[key].url);
      if (hasChild) {
        const nextKey = key + 1;
        let obj = {};
        obj[this.selData[key].key] = value;
        // console.log(obj);

        this.$http
          .post(this.selData[key].url, this.$qs.stringify(obj))
          .then(({ data }) => {
            // console.log(data.resData);
            if (data.resStatus == 0 && data.resData) {
              if (this.selData[nextKey]) {
                this.selData[nextKey] = data.resData;
              } else {
                this.selData.push(data.resData);
              }
              this.selData.splice(
                nextKey + 1,
                this.selData.length - nextKey - 1
              );
            } else {
              this.$notify({
                title: "错误",
                message: data.resMsg,
                type: "error",
                offset: 60
              });
            }
          })
          .catch(() => {
            this.$notify({
              title: "错误",
              message: "获取下级菜单时出错，请检查网络",
              type: "error",
              offset: 60
            });
          });
      } else {
        this.selData.splice(key + 1, this.selData.length - key - 1);
      }
    },
    getValue() {
      let arr = [];
      for (const i in this.selData) {
        arr.push({
          key: this.selData[i].key,
          value: this.$refs.cascaders[i].value
            ? this.$refs.cascaders[i].value.value
            : ""
        });
      }
      return arr;
    }
  }
};
</script>
